import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { KibbleThemeProvider } from '@televet/kibble-ui/theme';
import { Flex } from '@televet/kibble-ui/chakra';
import { queryClient } from '@/lib/trpc';
import { AuthContext } from '@/auth';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToasterInitializer } from '@/components/ui/toaster';

interface RouterContext {
  auth: AuthContext;
  pageTitle?: string;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <KibbleThemeProvider>
        <ToasterInitializer />
        <Flex className="RootLayout" h="100dvh" w="100%">
          <Outlet />
        </Flex>
      </KibbleThemeProvider>
    </QueryClientProvider>
  );
}
